import styled from "styled-components";

const Tribute = () => {
  return (
    <TributeContainer>
      <PosterWrapper>
        <PosterImage 
          src={"/img/tributePoster.jpg"} 
          alt="추모 행사 포스터" 
        />
      </PosterWrapper>
    </TributeContainer>
  );
};

const TributeContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const PosterWrapper = styled.div`
  text-align: center;
`;

const PosterImage = styled.img`
  max-width: 100%;
  height: auto;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

export default Tribute;